import React, { useState, createContext, useRef } from 'react';

export const CountdownContext = createContext();

export const CountdownContextProvider = ({ children }) => {
	const [countdown, setCountdown] = useState(-1);
	const countdownRef = useRef(-1);
	countdownRef.current = countdown;

	return (
		<CountdownContext.Provider value={{ countdownRef, setCountdown }}>
			{children}
		</CountdownContext.Provider>
	);
};
